export const en = {
  brandName: "TrendHome",
  home: {
    hero: {
      badge: "Top Rated Tech Gear",
      title: "Everything You Need",
      titleHighlight: "For Your Home",
      description: "Best prices, fast delivery, secure checkout.",
      freeShipping: "Fast Delivery",
      securePayment: "Secure Payment",
      support24: "24/7 Support",
      shopNow: "Shop Now",
      exploreCategories: "Browse Categories",
      featuredProducts: "Featured Products",
      toolsForEveryday: "Tools for everyday use",
      inStock: "In Stock",
      newInStock: "New in Stock",
      saveUpTo20: "Save up to 20% on your order",
      discountLabel: "Limited offer",
      useCode: "On selected home & lifestyle items",
    },
    featured: {
      title: "Featured Products",
      description: "Handpicked products that meet our quality standards",
      viewAll: "View All Products"
    },
    topRated: {
      title: "Top Rated Products",
      description: "Products loved by our customers",
      viewAll: "View All Products"
    },
    categories: {
      title: "Shop by Category",
      description: "Browse our wide selection of products organized by category",
      exploreProducts: "Explore products"
    }
  },
  navbar: {
    home: "Home",
    products: "Products",
    searchPlaceholder: "Search products...",
    cart: "Cart",
    cartItems: "items",
    shoppingCart: "Shopping Cart",
    signedInAs: "Signed in as",
    adminPanel: "Admin Panel",
    myOrders: "My Orders",
    profile: "Profile",
    signOut: "Sign Out",
    signIn: "Sign In",
    getStarted: "Register",
    favourites: "Favourites",
    favouritesEmpty: "You haven't added any favourites yet",
    favouritesSignInPrompt: "Sign in to save your favourite products"
  },
  footer: {
    about: {
      description: "Your trusted destination for quality products and exceptional service.",
      qualityProducts: "Quality Products",
      fastDelivery: "Fast Delivery",
      securePayment: "Secure Payment",
      ourStory: "Our Story",
      careers: "Careers",
      blog: "Blog",
      partnerships: "Partnerships"
    },
    customerService: {
      title: "Customer Service",
      helpCenter: "Help Center / FAQ",
      shippingDelivery: "Shipping & Delivery",
      returnPolicy: "Return Policy",
      trackOrder: "Track Order"
    },
    shopConfidence: {
      title: "Shop With Confidence",
      secureCheckout: "Secure Checkout",
      sslEncryption: "SSL Encryption",
      paymentMethods: "Payment Methods",
      warrantyPolicy: "Warranty Policy",
      buyerProtection: "Buyer Protection"
    },
    contact: {
      title: "Contact & Newsletter",
      phoneHours: "Mon-Fri 9AM-6PM EST",
      support247: "24/7 Support",
      stayUpdated: "Stay Updated",
      emailPlaceholder: "Enter your email",
      subscribe: "Subscribe"
    },
    bottom: {
      copyright: "© 2026 TrendHome. All rights reserved.",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      cookiePolicy: "Cookie Policy",
      dataDeletion: "Data Deletion"
    }
  },
  productDetail: {
    productNotFound: "Product not found",
    productNotFoundDesc: "The product you're looking for doesn't exist.",
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    freeShipping: "Fast delivery",
    quantity: "Quantity",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    productDetails: "Product Details",
    shippingReturns: "Shipping & Returns",
    description: "Description",
    productSpecifications: "Product Specifications",
    category: "Category",
    availability: "Availability",
    stockAvailable: "Stock Available",
    units: "units",
    rating: "Rating",
    notRated: "Not rated",
    warranty: "Warranty",
    included: "Included",
    dimensions: "Dimensions",
    color: "Color",
    material: "Material",
    notSpecified: "Not specified",
    keyFeatures: "Key Features",
    highQualityMaterials: "High-quality materials",
    highQualityMaterialsDesc: "Premium construction for durability",
    durableConstruction: "Durable construction",
    durableConstructionDesc: "Built to last with robust design",
    warrantyIncluded: "Warranty included",
    warrantyIncludedDesc: "Full protection for peace of mind",
    easyToMaintain: "Easy to maintain",
    easyToMaintainDesc: "Simple care and cleaning process",
    shippingInformation: "Shipping Information",
    freeShippingOver: "Free shipping on orders over",
    standardDelivery: "Standard delivery:",
    expressDelivery: "Express delivery:",
    trackingNumber: "Tracking number",
    trackingNumberDesc: "provided for all orders",
    returnPolicy: "Return Policy",
    dayReturnPolicy: "30-day return policy",
    dayReturnPolicyDesc: "for unused items",
    freeReturns: "Free returns",
    freeReturnsDesc: "for defective products",
    securePayment: "Secure payment processing",
    securePaymentDesc: "with encryption",
    customerSupport: "24/7 customer support",
    customerSupportDesc: "available",
    businessDays: "business days",
    noImageAvailable: "No image available",
    generalInfo: "General info",
    reviewsTab: "Reviews",
    reviewsCountLabel: "reviews",
    delivery: "Delivery",
    deliveryIntro: "Free standard shipping on orders over {amount}, plus free returns.",
    colType: "Type",
    colHowLong: "How long",
    colHowMuch: "How much",
    standardDeliveryName: "Standard delivery",
    expressDeliveryName: "Express delivery",
    pickUpInStore: "Pick up in store",
    free: "Free",
    returnTitle: "Return",
    returnIntro: "You have {days} days to return the item(s) using any of the following methods:",
    returnMethodStore: "Free store return",
    returnMethodCourier: "Free returns via courier pickup",
    favourite: "Add to Favourites",
    favouriteRemove: "Remove from Favourites",
    addedToFavourites: "Added to favourites",
    removedFromFavourites: "Removed from favourites",
    share: "Share",
    noReviewsTitle: "No reviews yet",
    noReviewsDesc: "Be the first to share your experience with this product.",
    similarItems: "Similar items"
  },
  roomPreview: {
    button: "See it in your room",
    title: "See it in your room",
    subtitle: "Upload a photo of your room and see how {product} looks in your space.",
    close: "Close",
    uploadCta: "Upload or take a photo",
    uploadHint: "JPEG, PNG or WebP, up to 12 MB",
    changePhoto: "Change photo",
    placementLabel: "Where should it go? (optional)",
    placementPlaceholder: "e.g. in the corner by the window",
    chipCorner: "In the corner",
    chipByWindow: "By the window",
    chipCenter: "In the center",
    chipAgainstWall: "Against the wall",
    remaining: "{count} of {limit} previews left today",
    noneLeft: "You've used all your previews for today. Please come back tomorrow.",
    generate: "Generate preview",
    generating: "Creating your preview...",
    generatingHint: "This usually takes 20-60 seconds. Please keep this window open.",
    poweredBy: "AI-generated preview - results are approximate.",
    before: "Your room",
    after: "With {product}",
    download: "Download",
    tryAnother: "Try another photo",
    addToCart: "Add to cart",
    invalidFile: "Please choose a JPEG, PNG or WebP image.",
    fileTooLarge: "That photo is too large (max 12 MB).",
    errorGeneric: "We couldn't create your preview. Please try another photo."
  },
  products: {
    filtering: "Filtering...",
    showingProducts: "Showing {start}-{end} of {total} products",
    filters: "Filters",
    searchProducts: "Search Products",
    searchPlaceholder: "Search by name or description...",
    category: "Category",
    allCategories: "All Categories",
    subcategory: "Subcategory",
    allSubcategories: "All Subcategories",
    sortBy: "Sort By",
    sortName: "Name A-Z",
    sortPriceLow: "Price: Low to High",
    sortPriceHigh: "Price: High to Low",
    sortRating: "Highest Rated",
    priceRange: "Price Range",
    minimumRating: "Minimum Rating",
    anyRating: "Any Rating",
    stars: "{rating}+ Stars",
    inStockOnly: "In Stock Only",
    clearAllFilters: "Clear All Filters",
    gridView: "Grid view",
    listView: "List view",
    noProductsFound: "No products found",
    tryAdjustingFilters: "Try adjusting your filters or search terms",
    clearFilters: "Clear Filters",
    previous: "Previous",
    next: "Next",
    lowStock: "Only {count} left",
    outOfStock: "Out of Stock"
  },
  cart: {
    title: "Shopping Cart",
    subtitle: "Review your items and proceed to checkout",
    addedToCart: "Added to cart",
    viewCart: "View Cart",
    emptyTitle: "Your Cart is Empty",
    emptyDescription: "No items have been added to your cart yet.",
    continueShopping: "Continue Shopping",
    item: "Item",
    items: "Items",
    quantity: "Quantity",
    perItem: "per item",
    total: "Total",
    removeItem: "Remove item",
    onlyLeftInStock: "Only {count} left in stock",
    addStockLimit: "Couldn't add — only {count} in stock",
    orderSummary: "Order Summary",
    promoCode: "Promo code",
    apply: "Apply",
    subtotal: "Subtotal ({count} items)",
    shipping: "Shipping",
    free: "Free",
    deliveryAtCheckout: "Calculated at checkout",
    tax: "Tax",
    proceedToCheckout: "Proceed to Checkout",
    freeShippingOver: "Free shipping on orders over 50₾",
    secureCheckout: "Secure checkout with SSL encryption",
    returnPolicy: "30-day return policy"
  },
  auth: {
    signIn: "Sign In",
    signInTitle: "Sign In",
    signInSubtitle: "Welcome back to your account",
    emailAddress: "Email Address",
    emailPlaceholder: "Enter your email",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    signingIn: "Signing in...",
    orContinueWith: "or continue with",
    continueWithGoogle: "Continue with Google",
    continueWithFacebook: "Continue with Facebook",
    dontHaveAccount: "Don't have an account?",
    createOneHere: "Create one here",
    bySigningIn: "By signing in, you agree to our",
    termsOfService: "Terms of Service",
    and: "and",
    privacyPolicy: "Privacy Policy",
    createAccount: "Create Account",
    createAccountTitle: "Create Account",
    createAccountSubtitle: "Join us and start shopping today",
    username: "Username",
    usernamePlaceholder: "Enter your username",
    firstName: "First Name",
    firstNamePlaceholder: "Enter your first name",
    lastName: "Last Name",
    lastNamePlaceholder: "Enter your last name",
    emailOrPhone: "Email or Phone",
    emailOrPhonePlaceholder: "Enter your email or phone number",
    createPassword: "Create a password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm your password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    passwordMismatch: "Passwords do not match",
    creatingAccount: "Creating account...",
    alreadyHaveAccount: "Already have an account?",
    signInHere: "Sign in here",
    byCreatingAccount: "By creating an account, you agree to our",
    registrationFailed: "Registration failed. Please try again.",
    loginFailed: "Incorrect email/phone or password.",
    phone: "Phone Number",
    phonePlaceholder: "5XX XX XX XX",
    emailOptional: "Email (optional)",
    emailOptionalPlaceholder: "Enter your email",
    sendCode: "Send Code",
    sendingCode: "Sending code...",
    verificationCode: "Verification Code",
    verificationCodePlaceholder: "6-digit code",
    codeSentTo: "We sent a code to",
    changeNumber: "Change number",
    resendCode: "Resend code",
    resendIn: "Resend in {seconds}s",
    verifyAndCreate: "Verify & Create Account",
    verifying: "Verifying...",
    forgotPasswordTitle: "Reset Password",
    forgotPasswordSubtitle: "Enter your email or phone number and we'll send you a code",
    newPassword: "New Password",
    newPasswordPlaceholder: "Enter a new password",
    resetPasswordBtn: "Reset Password",
    resetting: "Resetting...",
    backToLogin: "Back to sign in",
    passwordResetSuccess: "Password updated. Please sign in.",
    codeSentToast: "Verification code sent",
    mfaTitle: "Two-step verification",
    mfaEnrollSubtitle: "Add a phone number to secure your admin account",
    mfaVerify: "Verify & Sign In"
  },
  profile: {
    title: "Profile Settings",
    subtitle: "Manage your account information and preferences",
    notAuthenticated: "Not authenticated",
    pleaseLogIn: "Please log in to view your profile.",
    personalInformation: "Personal Information",
    edit: "Edit",
    username: "Username",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    userId: "User ID",
    accountActions: "Account Actions",
    editProfile: "Edit Profile",
    securitySettings: "Security Settings",
    accountStatus: "Account Status",
    active: "Active",
    signOut: "Sign Out",
    save: "Save Changes",
    cancel: "Cancel",
    saving: "Saving...",
    emailOrPhone: "Email or Phone",
    profileUpdated: "Profile updated successfully",
    updateFailed: "Failed to update profile",
    fillRequired: "Please fill in all fields",
    deliveryDetails: "Default Delivery Details",
    deliveryDetailsHint: "Saved here and used to prefill your checkout.",
    deliverySaved: "Delivery details saved",
    deliverySaveFailed: "Failed to save delivery details",
    adminBadge: "Administrator",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    updatePassword: "Update Password",
    passwordChanged: "Password changed successfully",
    passwordsDoNotMatch: "New passwords do not match",
    passwordChangeFailed: "Failed to change password",
    socialLoginNoPassword: "Password change isn't available for accounts created with Google login."
  },
  cookieConsent: {
    message: "We use cookies to make the site work and improve your experience. By continuing to use the site, you agree to our",
    cookiePolicy: "Cookie Policy",
    privacyPolicy: "Privacy Policy",
    terms: "Terms of Service",
    accept: "I Agree",
    decline: "Decline"
  },
  shippingPage: {
    title: "Shipping and Delivery",
    intro: "Delivery is carried out by our partner courier company, which ensures your order is delivered safely and on time across Georgia.",
    sections: [
      {
        title: "Delivery Process",
        text: "Once your order is confirmed, our partner courier company delivers the item to the address you provided."
      },
      {
        title: "Delivery Time",
        text: "Delivery times may vary depending on your location and product availability."
      },
      {
        title: "Delivery Cost",
        text: "The delivery fee is calculated based on the destination and package weight, and is added to your order total at checkout."
      }
    ]
  },
  dataDeletion: {
    title: "User Data Deletion",
    intro: "You can ask us to delete the personal data we hold about you at any time. This page explains how to make that request and what happens afterwards.",
    facebook: {
      title: "If you signed in with Facebook",
      text: "Removing TrendHome from your Facebook account tells us automatically — you do not need to contact us separately.",
      items: [
        "In Facebook, open Settings & privacy, then Settings.",
        "Go to \"Apps and websites\".",
        "Find TrendHome in the list and choose \"Remove\".",
        "Tick the option to delete the data TrendHome holds about you, then confirm."
      ],
      outro: "Facebook shows you a confirmation code once the request is sent. Enter it below to check the status of your deletion at any time."
    },
    manual: {
      title: "By email or phone",
      text: "If you registered with an email address or a phone number, send us a deletion request from the email address or phone number on your account. We verify that it is really yours and then delete your data.",
      items: [
        "Email: contact@trendhome.ge",
        "Phone: +995 557 65 10 75"
      ]
    },
    status: {
      title: "Check a deletion request",
      intro: "Enter the confirmation code you were given to see where your request stands.",
      label: "Confirmation code",
      placeholder: "e.g. 3f9c1a7b2e5d8c4a6b0f",
      submit: "Check status",
      checking: "Checking...",
      codeLabel: "Code:",
      requestedAt: "Requested:",
      completedAt: "Completed:",
      emptyCode: "Enter a confirmation code first.",
      notFound: "We could not find a request with that code. Please check it and try again.",
      error: "We couldn't check the status right now. Please try again in a moment.",
      result: {
        completed: "Your data has been deleted.",
        no_data: "We held no data for that account, so there was nothing to delete.",
        pending: "We have received your request and are processing it.",
        manual_review: "Our team is handling your request manually. It will be completed within 30 days.",
        failed: "Something went wrong while deleting your data. Our team has been notified and will finish the request manually."
      }
    },
    whatWeDelete: {
      title: "What we delete",
      text: "Once a request is confirmed, we remove:",
      items: [
        "Your account and profile details — name, email address, phone number and saved delivery address.",
        "Your shopping cart and your favourites.",
        "Any one-time verification codes tied to your email address or phone number.",
        "The link between your browsing history on the site and your account."
      ]
    },
    whatWeKeep: {
      title: "What we have to keep",
      text: "Records of completed purchases are retained because Georgian tax and accounting law requires it. We strip your name, email address, phone number and delivery address out of them, so they can no longer be traced back to you."
    },
    timing: {
      title: "How long it takes",
      text: "Requests that arrive through Facebook are processed immediately. Requests sent by email or phone are completed within 30 days of us confirming your identity."
    }
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated:",
    general: {
      title: "1. General Information",
      text: "This Privacy Policy sets out how trendhome (identification code: 58001025443, legal address: 62 Guramishvili Avenue, Tbilisi, Georgia) (hereinafter – the \u201cCompany\u201d, \u201cwe\u201d) collects, processes, stores, and protects the personal data of users when they use the website.",
      text2: "Personal data is processed in accordance with the applicable legislation of Georgia, including the requirements of the Law of Georgia \u201cOn Personal Data Protection\u201d."
    },
    dataWeCollect: {
      title: "2. What Personal Data Do We Collect?",
      intro: "When you use the website, the following data may be processed:",
      provided: {
        title: "2.1. Information Provided by the User",
        items: [
          "First and last name;",
          "Phone number;",
          "Email address;",
          "Delivery address;",
          "If an account is created – information related to the account;",
          "Information related to the order;",
          "Messages or requests you send us."
        ]
      },
      technical: {
        title: "2.2. Automatically Collected (Technical) Information",
        intro: "The system may automatically process:",
        items: [
          "IP address and device information;",
          "Operating system;",
          "Browser type and version;",
          "Date and time of the visit;",
          "Pages viewed and time spent on the website;",
          "Referring website or source;",
          "Cookies and similar tracking technologies."
        ]
      }
    },
    purposes: {
      title: "3. For What Purposes Do We Process Your Data?",
      intro: "Your personal data may be processed for the following purposes:",
      orderFulfillment: {
        title: "3.1. Order Processing and Fulfillment",
        text: "Identifying the user, receiving, processing, and forwarding orders, delivering items, and providing subsequent customer support."
      },
      accountManagement: {
        title: "3.2. Account Management",
        text: "Creating and managing an account (if applicable), saving settings, and providing a personalized experience."
      },
      communication: {
        title: "3.3. Communication",
        text: "Contacting the user, sending order updates, and responding to user requests and messages."
      },
      security: {
        title: "3.4. Website Improvement and Security",
        text: "Analyzing usage patterns, ensuring the security of the website and services, and preventing fraud, unauthorized access, and other offenses."
      },
      marketing: {
        title: "3.5. Marketing (Promotional Offers)",
        text: "Sending promotional offers and news only on the basis of your prior consent."
      }
    },
    legalBasis: {
      title: "4. Legal Basis for Data Processing",
      intro: "Personal data is processed only where there is an appropriate legal basis, including:",
      items: [
        "On the basis of your consent;",
        "For the purpose of performing a contract concluded or to be concluded with you;",
        "To fulfill a legal obligation imposed on the Company;",
        "On the basis of the Company\u2019s legitimate interest, provided that your rights and freedoms are not violated."
      ]
    },
    sharing: {
      title: "5. To Whom May the Data Be Transferred?",
      intro: "Your personal data is not sold, traded, or transferred to third parties for commercial purposes. Only when necessary, the data may be transferred to:",
      serviceProviders: {
        title: "5.1. Service Providers",
        items: [
          "Online payment service providers (banks);",
          "Courier companies (to deliver the order);",
          "IT infrastructure and hosting service providers."
        ]
      },
      legalAndGovernment: {
        title: "5.2. Legal and Governmental Requirements",
        items: [
          "Accounting or legal service providers;",
          "Governmental authorities, when this obligation is directly defined by law (a court decision, a tax request, etc.)."
        ]
      },
      note: "Note: all of the above parties are obligated to ensure the confidentiality and security of the data received."
    },
    retention: {
      title: "6. How Long Do We Keep the Data?",
      intro: "Personal data is stored only for the period necessary:",
      items: [
        "To achieve the purpose of the processing;",
        "To fulfill obligations provided for by law (including tax obligations);",
        "To resolve possible legal disputes."
      ],
      outro: "After the expiry of the specified period, the data is deleted or anonymized (so that the person can no longer be identified)."
    },
    security: {
      title: "7. How Do We Protect Your Data?",
      intro: "The Company uses appropriate technical and organizational security measures to protect personal data, including:",
      measures: {
        title: "7.1. Core Security Measures",
        items: [
          "Use of an encrypted connection (SSL/TLS protocol) when transmitting data;",
          "Access control systems and authentication mechanisms;",
          "Secure payment processing through appropriate and certified providers;",
          "Restricting access to personal data only to those employees who need it directly for their work."
        ]
      },
      statement: "Security statement: despite all reasonable measures we take, no system can guarantee 100% security of data transmission over the internet. The user acknowledges the inherent risks associated with exchanging data over the internet."
    },
    rights: {
      title: "8. Your Rights and Choices",
      intro: "In accordance with the applicable legislation, you have the right to:",
      access: {
        title: "8.1. Access and Update",
        text: "Receive information about the processing of your personal data and request a copy, correction, or update thereof."
      },
      marketing: {
        title: "8.2. Marketing Communications",
        text: "Opt out of marketing messages at any time by clicking the relevant unsubscribe link."
      },
      deletion: {
        title: "8.3. Data Deletion and Restriction of Processing",
        text: "Request the deletion of data (the \u201cright to be forgotten\u201d) or the restriction of data processing, except where retaining the data is mandatory by law or necessary for the performance of a contract."
      },
      withdraw: {
        title: "8.4. Withdrawal of Consent and Complaints",
        text: "Withdraw the consent you have given at any time and contact the Personal Data Protection Service if you believe that your rights have been violated."
      }
    },
    cookies: {
      title: "9. Third-Party Services and Cookies",
      text: "The website uses cookies and similar technologies to improve the website\u2019s performance, analyze user behavior, and for marketing purposes.",
      text2: "You can control or disable cookie settings through your browser. For more information, see the Cookie Policy available on the website."
    },
    changes: {
      title: "10. Changes to the Privacy Policy",
      text: "We are entitled to update this policy periodically in line with changes in legislation or technological processes. The updated version will be published on the website and will take effect upon publication.",
      text2: "Continuing to use our services after the changes are published means acceptance of the terms of the updated policy."
    },
    contactInfo: {
      title: "11. Contact Information",
      intro: "For any matters related to personal data or to exercise your rights, you can contact us:",
      items: [
        "Company: individual entrepreneur (trendhome.ge)",
        "Identification code: 58001025443",
        "Legal address: 62 Guramishvili Avenue, Tbilisi, Georgia",
        "Email: contact@trendhome.ge",
        "Phone: +995 557 65 10 75"
      ]
    }
  },
  terms: {
    title: "Terms of Service",
    lastUpdated: "Last updated:",
    introduction: {
      title: "1. Introduction",
      text: "Welcome to our ecommerce platform. These Terms of Service (\"Terms\") govern your use of our website, mobile applications, and services. By accessing or using our platform, you agree to be bound by these Terms and all applicable laws and regulations."
    },
    acceptance: {
      title: "2. Acceptance of Terms",
      text: "By creating an account, making a purchase, or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. These terms apply to all users of our platform."
    },
    accountRegistration: {
      title: "3. Account Registration and Security",
      accountCreation: {
        title: "3.1. Account Creation",
        text: "You must provide accurate and complete information when creating an account. You are responsible for maintaining the confidentiality of your account credentials."
      },
      accountSecurity: {
        title: "3.2. Account Security",
        text: "You are responsible for all activities that occur under your account. Notify us immediately of any unauthorized use or security breaches."
      },
      ageRequirements: {
        title: "3.3. Age Requirements",
        text: "You must be at least 18 years old to create an account and make purchases."
      }
    },
    productsAndServices: {
      title: "4. Products and Services",
      productDescriptions: {
        title: "4.1. Product Descriptions",
        text: "We strive to provide accurate product descriptions, images, and pricing."
      },
      pricing: {
        title: "4.2. Pricing",
        text: "All prices are subject to change without notice. We reserve the right to modify or discontinue products at any time."
      },
      availability: {
        title: "4.3. Availability",
        text: "Product availability is not guaranteed. We reserve the right to limit quantities and refuse service to anyone."
      },
      thirdPartyProducts: {
        title: "4.4. Third-Party Products",
        text: "Some products may be sold by third-party vendors. We are not responsible for third-party product quality or fulfillment."
      }
    },
    paymentTerms: {
      title: "5. Payment Terms",
      paymentMethods: {
        title: "5.1. Payment Methods",
        intro: "We accept various payment methods including credit cards, debit cards, and digital wallets. All payments are processed securely through our payment partners.",
        items: [
          "Payment is required at the time of order placement",
          "We reserve the right to refuse or cancel orders with suspicious payment activity",
          "Prices are in the currency specified on our website",
          "Sales tax and shipping fees will be added as applicable"
        ]
      }
    },
    shipping: {
      title: "6. Shipping and Delivery",
      shippingPolicies: {
        title: "6.1. Shipping Policies",
        items: [
          "Delivery times may vary based on location and product availability",
          "Shipping costs are calculated based on destination and package weight"
        ]
      }
    },
    returns: {
      title: "7. Returns and Refunds",
      returnPolicy: {
        title: "7.1. Return Policy",
        intro: "Items may be returned within 7 days of delivery, subject to the following conditions:",
        items: [
          "Items must be damaged or have a defect",
          "The item does not match the purchased product",
          "Return shipping costs are the responsibility of the customer unless the item is defective",
          "Refunds will be processed within 14 business days of receiving the returned item"
        ]
      }
    },
    intellectualProperty: {
      title: "8. Intellectual Property",
      intro: "Our website and its content, including text, graphics, logos, images, and software, are the property of our company and are protected by copyright, trademark, and other intellectual property laws.",
      text: "You may not reproduce, distribute, modify, or create derivative works from our content without our express written consent. All trademarks and trade names are the property of their respective owners."
    },
    indemnification: {
      title: "9. Indemnification",
      text: "You agree to indemnify, defend, and hold harmless our company and its officers, directors, employees, and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of our services or violation of these Terms."
    },
    governingLaw: {
      title: "10. Governing Law",
      text: "These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which our company is registered, without regard to its conflict of law provisions. Any disputes arising from these Terms or your use of our services shall be resolved in the courts of that jurisdiction."
    },
    changes: {
      title: "11. Changes to Terms",
      text: "We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the updated Terms on our website and updating the \"Last updated\" date. Your continued use of our services after such changes constitutes acceptance of the updated Terms."
    },
    contact: {
      title: "Contact Information",
      intro: "If you have any questions about these Terms of Service, please contact us:",
      email: "Email:",
      phone: "Phone:",
      address: "Address:"
    }
  },
  cookies: {
    title: "Cookie Policy",
    lastUpdated: "Last updated:",
    general: {
      title: "1. General Information",
      text: "This Cookie Policy explains how trendhome (identification code: 58001025443, legal address: 62 Guramishvili Avenue, Tbilisi, Georgia) (hereinafter \u2013 the \u201cCompany\u201d, \u201cwe\u201d) uses cookies and similar technologies on its website.",
      text2: "By using the website, you agree to the use of cookies in accordance with this policy. You can change your choice at any time through your browser settings or the cookie consent banner."
    },
    whatAreCookies: {
      title: "2. What Are Cookies?",
      text: "Cookies are small text files stored on your device (computer, tablet, or phone) when you visit a website. They help the website function properly, remember your preferences, and improve your browsing experience.",
      text2: "Similar technologies (such as local storage and pixels) may be used for the same purposes; in this policy they are all referred to as \u201ccookies\u201d."
    },
    types: {
      title: "3. What Types of Cookies Do We Use?",
      intro: "Depending on their purpose, we use the following categories of cookies:",
      essential: {
        title: "3.1. Essential (Technical) Cookies",
        text: "Necessary for the website to function \u2013 for example, keeping items in your cart, maintaining your session, and ensuring security. These cannot be disabled."
      },
      performance: {
        title: "3.2. Analytics / Performance Cookies",
        text: "Help us understand how visitors use the website (pages viewed, time spent, errors) so we can measure and improve its performance."
      },
      functional: {
        title: "3.3. Functional Cookies",
        text: "Remember your choices (such as language and preferences) to provide enhanced, personalized functionality."
      },
      marketing: {
        title: "3.4. Marketing (Targeting) Cookies",
        text: "May be set by us or our partners to show you relevant offers and measure the effectiveness of advertising. Used only with your consent."
      }
    },
    thirdParty: {
      title: "4. Third-Party Cookies",
      text: "Some cookies may be set by third-party service providers (for example, payment providers, analytics, or social media), whose use of data is governed by their own privacy policies.",
      text2: "The Company does not control third-party cookies and recommends that you review the relevant providers\u2019 policies."
    },
    managing: {
      title: "5. Managing and Controlling Cookies",
      intro: "You have full control over cookies:",
      browser: {
        title: "5.1. Browser Settings",
        text: "You can accept, block, or delete cookies through your browser settings. If you disable cookies, some parts of the website may not work correctly."
      },
      consent: {
        title: "5.2. Consent Banner",
        text: "When you first visit the website, you can accept or customize cookie categories through the consent banner, and change your choice at any time."
      }
    },
    retention: {
      title: "6. How Long Are Cookies Stored?",
      text: "Cookies are stored for different periods depending on their type: session cookies are deleted when you close the browser, while persistent cookies remain for a set period or until you delete them manually."
    },
    changes: {
      title: "7. Changes to the Cookie Policy",
      text: "We may update this Cookie Policy periodically to reflect changes in legislation, technology, or our practices. The updated version will be published on the website and take effect upon publication.",
      text2: "Continuing to use our services after the changes are published means acceptance of the updated policy."
    },
    contactInfo: {
      title: "8. Contact Information",
      intro: "For any matters related to the use of cookies or this policy, you can contact us:",
      items: [
        "Company: individual entrepreneur (trendhome.ge)",
        "Identification code: 58001025443",
        "Legal address: 62 Guramishvili Avenue, Tbilisi, Georgia",
        "Email: contact@trendhome.ge",
        "Phone: +995 557 65 10 75"
      ]
    }
  },
  checkout: {
    backToCart: "Back to Cart",
    title: "Checkout",
    subtitle: "Complete your purchase",
    item: "Item",
    items: "Items",
    emptyTitle: "No Items to Checkout",
    emptyDescription: "Your cart is empty. Add some items to proceed.",
    continueShopping: "Continue Shopping",
    shippingInfo: "Shipping Information",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    address: "Address",
    addressPlaceholder: "123 Main St",
    city: "City",
    phone: "Phone Number",
    phonePlaceholder: "e.g. 599 12 34 56",
    deliveryZone: "Delivery Zone",
    zoneTbilisi: "Tbilisi",
    zoneRegion: "Region",
    fillAllFields: "Please fill in all shipping fields",
    saveDeliveryPrompt: "Save these delivery details for next time?",
    verifyPhone: "Verify",
    verifyPhoneHint: "Verify your phone number to place the order.",
    phoneVerified: "Verified",
    enterSmsCode: "Enter the code we sent by SMS",
    confirmCode: "Confirm",
    sendingCode: "Sending...",
    verifyingPhone: "Verifying...",
    phoneVerifiedToast: "Phone number verified",
    verifyPhoneFirst: "Please verify your phone number first",
    resendCode: "Resend code",
    resendIn: "Resend in {seconds}s",
    verifyPhoneModalTitle: "Verify your phone number",
    verifyPhoneModalDesc: "Please enter the 6-digit code sent to {phone} to continue to payment.",
    orderSummary: "Order Summary",
    quantity: "Qty",
    subtotal: "Subtotal",
    shipping: "Shipping",
    free: "Free",
    total: "Total",
    includingTaxes: "Including all taxes",
    secureCheckout: "Secure Checkout",
    freeShipping: "Fast Delivery"
  },
  orders: {
    title: "My Orders",
    orderSingular: "order",
    orderPlural: "orders",
    emptyTitle: "No Orders Yet",
    emptyDescription: "Start shopping to see your orders here.",
    browseProducts: "Browse Products",
    quantity: "Qty",
    itemSingular: "item",
    itemPlural: "items",
    shippingAddress: "Shipping Address",
    payment: "Payment",
    cashOnDelivery: "Cash on Delivery",
    paymentMethod: {
      flitt: "Card Payment",
      card: "Card Payment",
      cod: "Cash on Delivery"
    },
    months: [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ],
    status: {
      pending: "Pending",
      paid: "Paid",
      confirmed: "Paid",
      processing: "Processing",
      shipped: "Shipped",
      delivered: "Delivered",
      cancelled: "Cancelled"
    }
  },
  payment: {
    title: "Payment",
    cardTitle: "Card Payment",
    cardDescription: "You will be securely redirected to Flitt to complete your payment by card.",
    payButton: "Pay",
    processing: "Processing...",
    redirecting: "Redirecting to secure payment...",
    failedToStart: "Failed to start payment",
    secureCheckout: "Secure Checkout",
    result: {
      verifyingTitle: "Verifying your payment",
      verifyingDescription: "Please wait while we confirm your payment.",
      successTitle: "Payment Successful!",
      successDescription: "Thank you for your purchase. Your payment has been received.",
      pendingTitle: "Payment Pending",
      pendingDescription: "Your payment is being processed. We'll update your order as soon as it's confirmed.",
      failedTitle: "Payment Failed",
      failedDescription: "Your payment could not be completed. Please try again.",
      orderNumber: "Order number:",
      viewOrders: "View My Orders",
      continueShopping: "Continue Shopping",
      tryAgain: "Try Again",
      backToCart: "Back to Cart"
    }
  },
  // Localized versions of backend (FastAPI/Pydantic) validation + auth messages,
  // keyed by the exact English string the API returns. Looked up after stripping
  // any leading "Value error, " prefix that Pydantic v2 adds.
  toasts: {
    loginSuccess: "Login successful!",
    loginFailed: "Login failed",
    registerSuccess: "Registration successful!",
    logoutSuccess: "Logged out successfully",
    tokenRefreshFailed: "Session refresh failed",
    cartLoadFailed: "Failed to load cart",
    cartLoginRequired: "Please log in to add items to cart",
    cartAddFailed: "Failed to add item to cart",
    cartUpdateSuccess: "Cart updated",
    cartUpdateFailed: "Failed to update cart",
    cartRemoveSuccess: "Item removed from cart",
    cartRemoveFailed: "Failed to remove item",
    wishlistLoginRequired: "Please log in to use favourites",
    wishlistUpdateFailed: "Could not update favourites",
  },
  apiErrors: {
    "Email or phone is required": "Email or phone is required",
    "Invalid email address": "Invalid email address",
    "Invalid phone number": "Invalid phone number",
    "Password must be at least 8 characters long": "Password must be at least 8 characters long",
    "Password must be at most 72 bytes long": "Password must be at most 72 bytes long",
    "Password must contain both letters and numbers": "Password must contain both letters and numbers",
    "Incorrect email or password": "Incorrect email or password",
    "This email or phone is already registered": "This email or phone is already registered",
    "Current password is incorrect": "Current password is incorrect",
    "Password change is not available for social login accounts": "Password change is not available for social login accounts",
    "This field is required": "This field is required",
    "Invalid code": "Invalid code",
    "This phone is already registered": "This phone is already registered",
    "This email is already registered": "This email is already registered",
    "invalid_phone": "Invalid phone number",
    "phone_taken": "This phone is already registered",
    "phone_not_verified": "Please verify your phone number before placing the order",
    "otp_invalid": "The code is invalid or has expired",
    "otp_cooldown": "Please wait a moment before requesting a new code",
    "otp_too_many_attempts": "Too many attempts. Please request a new code",
    "invalid_mfa": "Your session expired. Please sign in again",
    "Facebook login is not configured on the server": "Facebook login is not configured on the server",
    "Invalid Facebook token": "Facebook sign-in failed. Please try again.",
    "Admin accounts must sign in with a password": "Admin accounts must sign in with a password"
  } as Record<string, string>
};
